/**
 * WordPress dependencies
 */
import { store, getContext, getElement } from '@wordpress/interactivity';

const { state } = store('gt/ctv/filtres', {
    actions: {
        sortHeberg: (e) => {
            const element = getElement();
            const sortOrder = element.ref.value;

            store('gt/ctv').state.sort_order = sortOrder;

            document.querySelectorAll('.wp-block-post-template')
            .forEach(container => {
                const hebergements = [...container.querySelectorAll('.hebergement')];

                hebergements.sort((a, b) => {
                    const priceA = parseFloat(a.querySelector('.gt-ws-ctv-data-price')?.dataset.gtPrice) || 0;
                    const priceB = parseFloat(b.querySelector('.gt-ws-ctv-data-price')?.dataset.gtPrice) || 0;

                    return sortOrder === 'asc' ? priceA - priceB : priceB - priceA;
                });

                const fragment = document.createDocumentFragment();
                hebergements.forEach(hebergement => fragment.appendChild(hebergement));
                container.appendChild(fragment);
            });
        },
        runFilters: (e) => {
            const ctv = store("gt/ctv");
        
            if (e !== undefined && e.type !== "load") {

                // Find the container of the clicked filter
                let filterContainer = e.target.closest('.gt-hebergements-filtre');
        
                // Check/uncheck "All" checkbox based on individual selections
                let allCheckbox = filterContainer.querySelector('input[value=""]');
                let allChecked = filterContainer.querySelectorAll('input:checked:not([value=""])');
                allCheckbox.checked = allChecked.length === 0;
        
                // Store selected filter values in cookies and ctv state
                let cookieName = filterContainer.getAttribute('data-gt-cookie');
                

                if (cookieName) {
                    let cookieValue = Array.from(allChecked).map(checkbox => checkbox.value);
                    Cookies.set(cookieName, cookieValue);
                    // ctv.state[cookieName] = cookieValue;
                }
            }
        
            // Initialize the filters object and count of active filters
            let filters = {};
            let activeFilterCount = 0;
        
            // Loop over all active filters and collect the checked values
            document.querySelectorAll('.gt-hebergements-filtre').forEach(activeFilterContainer => {
                let filterName = activeFilterContainer.getAttribute('data-gt-filtre-name');
                let operator = activeFilterContainer.getAttribute('data-gt-filtre-operator') || 'OR'; // Default to "OR" operator
        
                if (filterName) {
                    let selectedValues = Array.from(activeFilterContainer.querySelectorAll('input:checked:not([value=""])'))
                        .map(input => input.value);
        
                    // Only add filters with selected values to the filters object
                    if (selectedValues.length > 0) {
                        filters[filterName] = {
                            values: selectedValues,
                            operator: operator
                        };
                        activeFilterCount++; // Count active filters with at least one checked value
                    }
                }
            });

            state.activeCheckboxes = document.querySelectorAll('.gt-hebergements-filtre input:checked:not([value=""])').length;
                
            // Hide/show each hebergement based on the selected filters
            let visibleHebergements = [];
            document.querySelectorAll('.gt-ws-ctv-disponibilites-query .hebergement, .gt-ws-ctv-contrepropositions-query .hebergement').forEach(hebergement => {
                let shouldShow = true;
        
                // Hide hebergement if it has data-gt-statut="indisponible"
                if (hebergement.querySelector('[data-gt-statut="indisponible"]')) {
                    shouldShow = false;
                }
                else{
                    // Check each filter against the data attributes of the hebergement
                    Object.keys(filters).forEach(filterName => {
                        let dataAttribute = hebergement.getAttribute(`data-gt-${filterName}`);
            
                        if (dataAttribute) {
                            // Convert the data-attribute value into an array if it's a string
                            let dataValues = dataAttribute.includes(',') ? dataAttribute.split(',') : [dataAttribute];

                            dataValues = dataValues.map(value => value.replace(/\[|\]/g, ''));

                            let filter = filters[filterName];
                            let { values, operator } = filter;
            
                            let matches = false;
                            switch (operator) {
                                case 'AND':
                                // Sélectionne le filtre actif correspondant au nom spécifié
                                let activeFilter = document.querySelector(`.gt-hebergements-filtre[data-gt-filtre-name="${filterName}"]`);
                                
                                // Crée un tableau `allValues` à partir de tous les inputs cochés dans le filtre actif, sauf ceux ayant une valeur vide
                                let allValues = Array.from(activeFilter.querySelectorAll('input:checked:not([value=""])'))
                                    .map(checkbox => {
                                        // Divise la valeur de chaque input par des virgules pour obtenir un tableau de valeurs
                                        let values = checkbox.value.split(',');

                                        // Retourne un objet indiquant s'il faut utiliser `some` (si plusieurs valeurs) ou `every` (si une seule valeur)
                                        return values.length > 1 ? { type: 'some', values } : { type: 'every', values };
                                    });

                                // Évalue si l'hébergement doit correspondre en fonction du type de comparaison requis (`some` ou `every`)
                                // CTOUTVERT peut avoir plusieur code d'option en fonction de la catégorie de l'hébergement (ex: wifi pictch ou wifi location)
                                matches = allValues.every(item => {
                                    if (item.type === 'some') {
                                        // Vérifie si au moins une valeur de l'input correspond aux `dataValues`
                                        return item.values.some(value => dataValues.includes(value));
                                    } else {
                                        // Vérifie si toutes les valeurs de l'input correspondent aux `dataValues`
                                        return item.values.every(value => dataValues.includes(value));
                                    }
                                });

                                break;


                                case '<=':
                                    // Match if all dataValues are less than or equal to filter values (assuming numerical comparison)
                                    matches = values.every(value => parseInt(dataValues[0]) <= parseInt(value));
                                    break;
                                case '>=':
                                    // Match if all dataValues are greater than or equal to filter values (assuming numerical comparison)
                                    matches = values.every(value => parseInt(dataValues[0]) >= parseInt(value));
                                    break;
                                case 'OR':
                                default:
                                    // Match if any filter value is present in dataValues (default behavior)
                                    matches = values.some(value => dataValues.includes(value));
                                    break;
                            }
            
                            if (!matches) {
                                shouldShow = false;
                            }
                        }
                    });
                }
        
                // Toggle visibility based on the filter match
                if (shouldShow) {
                    hebergement.style.display = '';
                    visibleHebergements.push(hebergement); // Track visible hebergements
                } else {
                    hebergement.style.display = 'none';
                }
            });
        
            document.querySelectorAll('.gt-hebergements-filtre').forEach(activeFilterContainer => {
                let filterName = activeFilterContainer.getAttribute('data-gt-filtre-name');
                let filterOperator = activeFilterContainer.getAttribute('data-gt-filtre-operator');
            
                let selectedCheckboxes = activeFilterContainer.querySelectorAll('input:checked:not([value=""])');
                let activeFilterCount = document.querySelectorAll('.gt-hebergements-filtre input:checked:not([value=""])').length;
                let isSingleActiveFilter = selectedCheckboxes.length > 0 && activeFilterCount === selectedCheckboxes.length;
            
                activeFilterContainer.querySelectorAll('input[type="checkbox"]').forEach(checkbox => {
                    let checkboxValues = checkbox.value.split(','); // Séparer les valeurs par virgule
                    if (checkbox.value === '') return; // Ne pas désactiver "Tous"
            
                    let shouldEnable = false;
                    let isChecked = checkbox.checked; // Vérifier si le checkbox est coché
            
                    // ✅ Si ce filtre est le seul actif, toutes ses cases doivent être activables
                    if (isSingleActiveFilter) {
                        shouldEnable = true;
                    } 
                    else {
                        visibleHebergements.forEach(hebergement => {
                            let dataAttribute = hebergement.getAttribute(`data-gt-${filterName}`);
                            // Hide hebergement if it has data-gt-statut="indisponible"
                            if (hebergement.querySelector('[data-gt-statut="indisponible"]')) {
                                shouldEnable = false;
                            }
                            else if (dataAttribute) {
                                let dataValues = dataAttribute.split(',').map(value => value.replace(/\[|\]/g, '').trim());
            
                                // Vérifier si AU MOINS UNE valeur de la checkbox est présente dans l'hébergement visible
                                let matches = checkboxValues.some(value => dataValues.includes(value));
            
                                if (matches) {
                                    shouldEnable = true;
                                }
                            }
                        });
                    }
            
                    // ✅ Désactiver si aucun hébergement visible ne correspond, sauf si déjà coché
                    checkbox.disabled = !shouldEnable && !isChecked;
                });
            });
            
            
        

            
            // Hide contreproposition if no hebergements are visible
            let disponibilites = document.querySelectorAll('.gt-ws-ctv-disponibilites-query');
            if (disponibilites) {
                disponibilites.forEach(disponibilite => {
                    let visibleInDisponibilites = disponibilite.querySelectorAll('.hebergement:not([style*="display: none"])').length;
                    let noResults = disponibilite.querySelectorAll('.wp-block-query-no-results').length;
                    if (visibleInDisponibilites === 0 && noResults === 0) {
                        // disponibilite.classList.add('gt-ws-ctv-no-filter-results');
                        const noResultsElement = disponibilite.querySelector('.wp-block-gt-gt-ws-ctv-product-no-results');
                        if (noResultsElement) {
                            noResultsElement.style.display = 'block';
                            noResultsElement.removeAttribute('hidden');
                        }
                    } else {
                        // disponibilite.classList.remove('gt-ws-ctv-no-filter-results');
                        const noResultsElement = disponibilite.querySelector('.wp-block-gt-gt-ws-ctv-product-no-results');
                        if (noResultsElement) {
                            noResultsElement.style.display = 'none';
                            noResultsElement.setAttribute('hidden', 'true');
                        }
                    }
                });
            }

            // Hide contreproposition if no hebergements are visible
            let contrepropositions = document.querySelectorAll('.gt-ws-ctv-contrepropositions-query');
            if (contrepropositions) {
                contrepropositions.forEach(contreproposition => {
                    let visibleInContreproposition = contreproposition.querySelectorAll('.hebergement:not([style*="display: none"])').length;
                    if (visibleInContreproposition === 0) {
                        contreproposition.classList.add('gt-ws-ctv-no-filter-results');
                    } else {
                        contreproposition.classList.remove('gt-ws-ctv-no-filter-results');
                    }
                });
            }

            // Hide indisponibles if no hebergements are visible
            let indisponibles = document.querySelectorAll('.gt-ws-ctv-indisponibles-query');
            if (indisponibles) {
                indisponibles.forEach(indisponible => {
                    let visibleInIndisponibles = indisponible.querySelectorAll('.hebergement:not([style*="display: none"])').length;
                    if (visibleInIndisponibles === 0) {
                        indisponible.classList.add('gt-ws-ctv-no-filter-results');
                    } else {
                        indisponible.classList.remove('gt-ws-ctv-no-filter-results');
                    }
                });
            }

            // Execute the submission with the current state
            // ctv.actions.submitForm();

        },        
        clearFilter: (e) => {
            const ctv = store("gt/ctv");
            let checkboxes = e.target.closest('.gt-hebergements-filtre').querySelectorAll('input[type="checkbox"]');
            checkboxes.forEach(checkbox => {
                checkbox.checked = false;
            });
            e.target.checked = true;

            let cookieName = e.target.closest('.gt-hebergements-filtre').getAttribute('data-gt-cookie');
            if (cookieName) {
                Cookies.set(cookieName, []);
                ctv.state[cookieName] = [];
            }

            store('gt/ctv/filtres').actions.runFilters(e);

            // ctv.actions.submitForm();
        },
        clearAllFilters: (e) => {
            const ctv = store("gt/ctv");
            let checkboxes = document.querySelectorAll('.gt-hebergements-filtre input[type="checkbox"]');
            checkboxes.forEach(checkbox => {
                checkbox.checked = checkbox.value != "" ? false : true;

                let cookieName = checkbox.closest('.gt-hebergements-filtre').getAttribute('data-gt-cookie');
                if (cookieName) {
                    Cookies.set(cookieName, []);
                    ctv.state[cookieName] = [];
                }

            });




            // let cookiesNames = document.querySelectorAll('.gt-hebergements-filtre').getAttribute('data-gt-cookie');
            // cookiesNames.forEach(cookieName => {
            //     if (cookieName) {
            //         Cookies.set(cookieName, []);
            //         ctv.state[cookieName] = [];
            //     }
            // });

            store('gt/ctv/filtres').actions.runFilters();

        },
        toggleSidebar: (e) => {
            const context = getContext();
            context.isSidebarOpen = !context.isSidebarOpen;

            document.body.classList.toggle('gt-ws-sidebar-toggled');

            // let sidebar = document.querySelector('.gt-hebergements-filtres__sidebar');

            // if(!sidebar) return;
            // sidebar.classList.toggle('gt-hebergements-filtres__sidebar--opened');

            // if(sidebar.classList.contains('gt-hebergements-filtres__sidebar--opened')){
            //     sidebar.setAttribute('aria-expanded', 'true');
            // }
            // else{
            //     sidebar.setAttribute('aria-expanded', 'false');
            // }

        },
        toggleFilter: (e) => {
            const context = getContext();
            if(!context.isAccordeon) return;

            let filter = e.target.closest('.gt-hebergements-filtre');
            filter.classList.toggle('closed');

            if(filter.classList.contains('closed')){
                filter.setAttribute('aria-expanded', 'false');
            }
            else{
                filter.setAttribute('aria-expanded', 'true');
            }

        },
        handleKeydown: (e) => {
            if (e.key === 'Escape') {
                store('gt/ctv/filtres').actions.toggleSidebar(e);
            }

            const focusableElements = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';
            const sidebar = document.querySelector('.gt-hebergements-filtres__sidebar');
            const firstFocusableElement = sidebar.querySelectorAll(focusableElements)[0];
            const focusableContent = sidebar.querySelectorAll(focusableElements);
            const lastFocusableElement = focusableContent[focusableContent.length - 1];

            let isTabPressed = e.key === 'Tab' || e.keyCode === 9;

            if (!isTabPressed) {
                return;
            }

            if (e.shiftKey) {
                if (document.activeElement === firstFocusableElement) {
                    lastFocusableElement.focus();
                    e.preventDefault();
                }
            } else {
                if (document.activeElement === lastFocusableElement) {
                    firstFocusableElement.focus();
                    e.preventDefault();
                }
            }
        },
        stickButton: (e) => {
            const element = getElement();
            const scrollTop = window.scrollY;
            const actionsBottom = element.ref.getBoundingClientRect().bottom + window.scrollY;
            const height = element.ref.offsetHeight;
            element.ref.querySelector('.gt-hebergements-actions-placeholder').style.height = `${height}px`;

            if (scrollTop > actionsBottom) {
                state.filterButtonSticked = true;
            } else {
                state.filterButtonSticked = false;
            }
        }
    }
});

// Sticky btn

// window.addEventListener('load', () => {
//     const actions = document.querySelector('.gt-hebergements-actions');
//     actions.style.height = `${actions.offsetHeight}px`;
// });

// window.addEventListener('load resize', () => {
//     const actions = document.querySelector('.gt-hebergements-actions');
//     actions.style.height = `${actions.offsetHeight}px`;
// });

// window.addEventListener('scroll', () => {
//     const actions = document.querySelector('.gt-hebergements-actions');
//     const scrollTop = window.scrollY;
//     const actionsBottom = actions.getBoundingClientRect().bottom + window.scrollY;

//     if (scrollTop > actionsBottom) {
//         actions.classList.add('sticked');
//     } else {
//         actions.classList.remove('sticked');
//     }
// });